@if (incomeTaxEntity$ | async) {
  @if (heeftSamenwerkingsverband) {
    <form [formGroup]="formGroup">
      @if (isDefAangifte) {
        <snelstart-ui-number-form-control [decimals]="0"
                                          align="right"
                                          class="custom-input-250"
                                          formControlName="aandeelBelastingplichtigeInKapitaalVolgensContract"
                                          id="aandeelKapitaalContract"
                                          label="Aandeel in eindvermogen"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
        <snelstart-ui-number-form-control [decimals]="0"
                                          align="right"
                                          class="custom-input-250"
                                          formControlName="aandeelBelastingplichtigeInBeginVermogen"
                                          id="aandeelKapitaalOverig"
                                          label="Aandeel in beginvermogen"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      }
      <snelstart-ui-number-form-control [decimals]="0"
                                        align="right"
                                        class="custom-input-250"
                                        formControlName="vergoedingVoorArbeidBelastingplichtige"
                                        id="aandeelKapitaalOverig"
                                        label="Vergoeding voor arbeid"
                                        prefix="€"
      >
      </snelstart-ui-number-form-control>
      <snelstart-ui-number-form-control [decimals]="0"
                                        align="right"
                                        class="custom-input-250"
                                        formControlName="overigeVergoedingenBelastingplichtige"
                                        id="aandeelKapitaalOverig"
                                        label="Overige vergoedingen"
                                        prefix="€"
      >
      </snelstart-ui-number-form-control>
      <snelstart-ui-number-form-control [decimals]="0"
                                        align="right"
                                        class="custom-input-250"
                                        formControlName="aandeelRestantWinstBelastingplichtige"
                                        id="aandeelKapitaalOverig"
                                        label="Aandeel in restant winst"
                                        prefix="€"
      >
      </snelstart-ui-number-form-control>
      <snelstart-ui-number-form-control [calculate]="berekenTotaal()"
                                        [decimals]="0"
                                        [disabledControl]="true"
                                        align="right"
                                        class="custom-input-250"
                                        formControlName="totaalResultaat"
                                        id="totaalResultaat"
                                        label="Totaal winstaandeel"
                                        prefix="€"
      >
      </snelstart-ui-number-form-control>
    </form>
  } @else {
    <p>
      De geselecteerde onderneming is geen samenwerkingsverband.
    </p>
  }
} @else {
  <p>Er zijn geen ondernemingen gevonden.</p>
}
